import { type TFunction } from "i18next";
import { type TextFieldValidationOptions } from "@/components/common/formElements/hooks/useTextFieldController";
import { type TextFieldType } from "@/components/common/formElements/types";
import type { FieldValues } from "react-hook-form";

export function applyTextValidationOptions<TFieldValues extends FieldValues>(
  t: TFunction,
  type: TextFieldType,
  options: TextFieldValidationOptions<TFieldValues> = {},
) {
  const rules = { ...options };

  switch (type) {
    case "text": {
      rules.setValueAs = (value: string) => value.trim();
      break;
    }

    case "number": {
      rules.valueAsNumber = true;
      break;
    }

    case "email": {
      rules.validate = {
        isEmail: (value: unknown) => {
          if (
            value &&
            typeof value === "string" &&
            !/^[\w-+.&]+@([\w-]+\.)+[\w-]{2,14}$/.test(value)
          ) {
            return t("validation.error.code.INVALID_EMAIL");
          }
        },
        ...rules.validate,
      };
      break;
    }

    default:
      break;
  }

  return rules;
}
